import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProps } from 'react-router';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import {
  EquipmentHttpService,
  PermittingHttpService,
} from '@core/services/http';
import { usePermittingTabPrefetch } from '@core/utils/hooks';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { EditablePage } from '@shared/components';
import { PermittingActions } from '@store/actions';
import { PermittingSelectors } from '@store/selectors';
import { PermittingSOFInformation } from './components/sof-information';

export const PermittingSOFTab: FC<RouterProps> = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isLoading = useSelector(PermittingSelectors.getTabLoadingState('sof'));
  const isDataLoaded = useSelector(PermittingSelectors.isTabDataLoaded('sof'));
  const sof = useSelector(PermittingSelectors.getSofTabData);

  usePermittingTabPrefetch('sof', projectBundleID);

  const fetchData = async () => {
    if (!isDataLoaded) {
      dispatch(
        PermittingActions.setTabLoading.done({
          tabName: 'sof',
          isLoading: true,
        }),
      );

      await HttpService.getHttpRequests(
        EquipmentHttpService,
      ).getEquipmentTypes();

      await HttpService.getHttpRequests(
        PermittingHttpService,
      ).getPermittingSofData(projectBundleID);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, isDataLoaded]);

  if (isLoading || !isDataLoaded || !sof) {
    return (
      <div className="prov-permitting-sof loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <EditablePage
      editableComponent={PermittingSOFInformation}
      canUserEdit={false}
    />
  );
};
